"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSession = void 0;
var ResponseError_1 = require("../ErrorHandlers/ResponseError");
var PaymentSession = /** @class */ (function () {
    function PaymentSession(clientSetting, formSettings, api, checkoutTraceId) {
        this.clientSetting = clientSetting;
        this.formSettings = formSettings;
        this.api = api;
        this.checkoutTraceId = checkoutTraceId || null;
    }
    PaymentSession.prototype.prepareError = function (err, data) {
        if (err && err instanceof Error) {
            return {
                error: JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err))),
                data: data,
            };
        }
        else {
            return { error: "Can't serialize error", data: data };
        }
    };
    PaymentSession.prototype.getTrace = function (headers) {
        return [
            headers.get('x-paltabrain-trace-id'),
            headers.get('x-paltabrain-request-id'),
        ];
    };
    PaymentSession.prototype.logErrorEvent = function (eventName, data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.logEvent('error', eventName, data, headers)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.notifyPaymentStatusChange = function (status, paymentMethodType) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 5]);
                        if (!this.clientSetting.onPaymentStatusChange) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.clientSetting.onPaymentStatusChange(status, paymentMethodType)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_payment_status_change_error', this.prepareError(err_1))];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.notifyError = function (error, description) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 5]);
                        if (!this.clientSetting.onError) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.clientSetting.onError(error, description)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_error', this.prepareError(err_2))];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.onBeforePaymentCreate = function (data, handler) {
        return __awaiter(this, void 0, void 0, function () {
            var paymentMethodType, updatedOrderId, startCheckoutRequest, response, data_1, _a, traceId, requestId, statusCode, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        paymentMethodType = data.paymentMethodType;
                        // send PENDING event to onPaymentStatusChange
                        return [4 /*yield*/, this.notifyPaymentStatusChange('PENDING', paymentMethodType)];
                    case 1:
                        // send PENDING event to onPaymentStatusChange
                        _b.sent();
                        updatedOrderId = sessionStorage.getItem('updatedOrderId');
                        startCheckoutRequest = {
                            orderId: updatedOrderId ? updatedOrderId : this.formSettings.orderId,
                        };
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 9, , 13]);
                        return [4 /*yield*/, this.api.startCheckout(startCheckoutRequest)];
                    case 3:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        data_1 = _b.sent();
                        _a = this.getTrace(response.headers), traceId = _a[0], requestId = _a[1];
                        statusCode = data_1 === null || data_1 === void 0 ? void 0 : data_1.status;
                        if (!(statusCode !== 'success')) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.logErrorEvent('cant_start_checkout', this.prepareError(Error('cant_start_checkout'), {
                                paltabrain_trace_id: traceId,
                                paltabrain_request_id: requestId,
                                request: startCheckoutRequest,
                                response: data_1,
                            }))];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.notifyError(new ResponseError_1.ResponseError(data_1), 'Can not start checkout')];
                    case 7:
                        _b.sent();
                        return [2 /*return*/, handler.handleFailure()];
                    case 8: return [3 /*break*/, 13];
                    case 9:
                        err_3 = _b.sent();
                        return [4 /*yield*/, this.logErrorEvent('cant_start_checkout', this.prepareError(err_3, { request: startCheckoutRequest }))];
                    case 10:
                        _b.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)];
                    case 11:
                        _b.sent();
                        return [4 /*yield*/, this.notifyError(err_3, 'Can not start checkout')];
                    case 12:
                        _b.sent();
                        return [2 /*return*/, handler.handleFailure()];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.onCheckoutComplete = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedOrderId, completeCheckoutRequest, paymentMethodType, rawResponse, data_2, _a, traceId, requestId, status_1, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedOrderId = sessionStorage.getItem('updatedOrderId');
                        completeCheckoutRequest = {
                            orderId: updatedOrderId ? updatedOrderId : this.formSettings.orderId,
                        };
                        paymentMethodType = data.paymentMethodType;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, , 14]);
                        return [4 /*yield*/, this.api.onSuccessCheckout(completeCheckoutRequest)];
                    case 2:
                        rawResponse = _b.sent();
                        return [4 /*yield*/, rawResponse.json()];
                    case 3:
                        data_2 = _b.sent();
                        _a = this.getTrace(rawResponse.headers), traceId = _a[0], requestId = _a[1];
                        status_1 = data_2 === null || data_2 === void 0 ? void 0 : data_2.status;
                        if (!(status_1 == 'success')) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.notifyPaymentStatusChange('COMPLETE', paymentMethodType)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 5: return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.notifyError(new ResponseError_1.ResponseError(rawResponse), 'Can not complete checkout')];
                    case 7:
                        _b.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_checkout_complete_error', this.prepareError(Error('on_checkout_complete_error'), {
                                paltabrain_trace_id: traceId,
                                paltabrain_request_id: requestId,
                                request: completeCheckoutRequest,
                                response: rawResponse,
                            }))];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 14];
                    case 10:
                        err_4 = _b.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('ERROR', paymentMethodType)];
                    case 11:
                        _b.sent();
                        return [4 /*yield*/, this.notifyError(err_4, 'Can not complete checkout')];
                    case 12:
                        _b.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_checkout_complete_error', this.prepareError(err_4, {
                                request: completeCheckoutRequest,
                                response: data,
                            }))];
                    case 13:
                        _b.sent();
                        return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSession.prototype.onCheckoutFail = function (error, data) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedOrderId, failCheckoutRequest, paymentMethodType, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updatedOrderId = sessionStorage.getItem('updatedOrderId');
                        failCheckoutRequest = {
                            orderId: updatedOrderId ? updatedOrderId : this.formSettings.orderId,
                        };
                        paymentMethodType = data === null || data === void 0 ? void 0 : data.paymentMethodType;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 7]);
                        return [4 /*yield*/, this.api.onFailCheckout(failCheckoutRequest)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.notifyPaymentStatusChange('FAIL', paymentMethodType)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.notifyError(error, 'Checkout failed')];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        err_5 = _a.sent();
                        return [4 /*yield*/, this.logErrorEvent('on_checkout_fail_error', this.prepareError(err_5, __assign({}, failCheckoutRequest)))];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return PaymentSession;
}());
exports.PaymentSession = PaymentSession;
//# sourceMappingURL=index.js.map